export default "__VITE_ASSET__C$A71Qto__"